import { SvgIconProps, SvgIcon } from "@mui/material";

const MenuUnfoldOutlined = (props: SvgIconProps) =>{
    return (
        <SvgIcon {...props}>
            <path d="M0 0h24v24H0V0z" fill="none"/>
            <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
        </SvgIcon>
    );
}
export default MenuUnfoldOutlined;
